import { chunk, flatten, isEmpty } from 'lodash';

import {
  COLLECTION_ITEM_TYPES,
  COLLECTION_N_COLUMNS,
  COLLECTION_STORY_CARDS_TARGETING,
} from 'constants/collection';

export const insertStoryCards = (rows, storyCardPlacements, columns) => {
  if (!storyCardPlacements || storyCardPlacements.length === 0) {
    return rows;
  }

  let allItems = flatten(rows);
  let modifiedRows = [];

  storyCardPlacements.sort((a, b) => a.row - b.row);

  storyCardPlacements.forEach(placement => {
    const storyCardComponent = {
      id: placement.storyCard.id,
      type: placement.storyCard.type,
    };

    if (columns === COLLECTION_N_COLUMNS.THREE) {
      // For 3 column layout insert every STORY_CARD as the last item in the specified row
      const position = (placement.row + 1) * columns - 1;
      allItems.splice(position, 0, storyCardComponent);
    } else if (columns === COLLECTION_N_COLUMNS.TWO) {
      const basePosition = placement.row * columns;

      if (storyCardComponent.type === COLLECTION_ITEM_TYPES.STORY_CARD) {
        // For 2 column layout insert STORY_CARD as the last item in the specified row
        const position = basePosition + columns - 1;
        allItems.splice(position, 0, storyCardComponent);
      } else if (storyCardComponent.type === COLLECTION_ITEM_TYPES.STORY_CARD_V2) {
        // For 2 column layout insert STORY_CARD_V2 as a new row, empty object for chunk to chunk
        allItems.splice(basePosition, 0, storyCardComponent, {});
      }
    }
  });

  modifiedRows = chunk(allItems, columns);

  // Remove empty objects
  const cleanRows = modifiedRows.map(row => row.filter(item => !isEmpty(item)));

  return cleanRows;
};

export const removeDuplicateAndOutOfBoundsPlacements = (placements, rowCount) => {
  const uniquePlacements = {};
  placements.forEach(placement => {
    if (placement.row < rowCount) {
      // Prioritize dynamic yield story cards over static ones
      if (
        !uniquePlacements[placement.row] ||
        placement.targeting === COLLECTION_STORY_CARDS_TARGETING.DYNAMIC_YIELD
      ) {
        uniquePlacements[placement.row] = placement;
      }
    }
  });
  return Object.values(uniquePlacements);
};
